import axios from "axios";
import translateErrorMessageFromBackend from "./TranslationService";
import { DEFAULT_ERROR_MESSAGE } from "../../HistoriografijaConstants";
import { addAuthorizationToHeaders } from '../CommonService'
import noRefreshClient from "./NoRefreshClient";
import { setLocalStorage } from "../StorageHelper";

const refreshClient = axios.create({
    baseURL: process.env.REACT_APP_HISTORIOGRAFIJA_BACKEND,
    timeout: 60000,
    withCredentials: true
})

const sendRefreshTokenRequest = async (originalRequest) => {
    let headers = addAuthorizationToHeaders({})

    return noRefreshClient.get('refresh', { headers })
            .then(async data => {
                const newToken = data.data.token
                setLocalStorage("token", newToken)

                // Retry the failed request
                originalRequest.headers.authorization = `Bearer ${newToken}`
                return noRefreshClient.request(originalRequest)
                    .then(data => data)
                    .catch(err => Promise.reject(err))
            })
            .catch(error => {
                error.config._retry = true
                return Promise.reject(error)
            })
}

export const handleErrors = async (error) => {
    const originalRequest = error.config
    if (error.response === null || error.response === undefined ||
        error.message === null || error.message === undefined) {
        error.message = DEFAULT_ERROR_MESSAGE
    } else if ((error.response.status === 401 || error.response.status === 403) && !originalRequest._retry) { // If it is not the refresh request that failed
        originalRequest._retry = true
        return sendRefreshTokenRequest(originalRequest)
            .then(response => response)
            .catch(err => Promise.reject(err))
    } else {
        error.message = translateErrorMessageFromBackend(error.response.data.message)
    }
    return Promise.reject(error)
}

export default refreshClient